export const DeepLinkQueryParamsHelper = (url: string, key: string) => {
  const urlObject = new URL(url.replace('AMNOne://', 'https://'));
  return urlObject.searchParams.get(key);
};
